import React from "react";
import StackGrid from "react-stack-grid";

function VibeGridModule({ children, postCount, vibeGridTitle }) {
  console.log("vibe grid title: ", vibeGridTitle);
  return (
    <section className="h-full w-full rounded-md px-4 py-6 shadow-socialglass">
      <h2 className="mb-4 flex items-center gap-2 text-left text-2xl font-semibold">
        {vibeGridTitle}
        <p className="mb-0 pb-0 text-xl font-light text-gray-500">
          ({postCount} submitted posts)
        </p>
      </h2>

      {/* Tabs  - removed for now*/}
      {/* <div className="mb-6 flex space-x-2">
        <button className="rounded-lg bg-gray-200 px-3 py-1 text-sm font-medium">
          All posts
        </button>

        <div className="border-l"></div>
        <button className="rounded-lg px-3 py-1 text-sm font-medium hover:bg-gray-100">
          Other
        </button>
      </div> */}

      {children}
    </section>
  );
}

export default VibeGridModule;
